import React, { useEffect, useState } from "react";

// ✅ Update to live backend HTTPS URL
const API_URL = "https://dgl-core-9x7.dailygolive.in/api/gallery";

const PhotoGallery = () => {
  const [galleryItems, setGalleryItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Fetch gallery items on component mount
  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await fetch(API_URL);
        if (!res.ok) throw new Error("Failed to fetch gallery");
        const data = await res.json();
        setGalleryItems(data);
      } catch (err) {
        console.error("❌ Error fetching gallery:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, []);

  return (
    <section className="px-4 sm:px-6 md:px-10 py-12 md:py-20 max-w-7xl mx-auto">
      {/* Heading */}
      <div className="text-center mb-12">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-green-900 mb-4">
          Photo Gallery
        </h1>
        <p className="text-gray-700 text-base sm:text-lg max-w-2xl mx-auto">
          Explore how DailyGoLive connects wholesale suppliers, farmers, and
          distributors with businesses across India through smarter sourcing and
          reliable delivery.
        </p>
      </div>

      {/* Gallery Grid */}
      {loading ? (
        <p className="text-center text-gray-500">Loading gallery...</p>
      ) : galleryItems.length === 0 ? (
        <p className="text-center text-gray-500">No gallery items found.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryItems.map((item) => (
            <div
              key={item._id}
              className="rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition duration-300 bg-white group"
            >
              {/* Image */}
              <div className="overflow-hidden">
                <img
                  src={item.imageUrl} // ✅ live backend URL
                  alt={item.title}
                  className="w-full h-56 object-cover transform group-hover:scale-105 transition duration-500"
                />
              </div>

              {/* Text Content */}
              <div className="p-5">
                <h2 className="text-lg font-semibold text-green-800 mb-2">
                  {item.title}
                </h2>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default PhotoGallery;
